(function () {
  if (window.MCSqualaneLandingLoaded) return;
  window.MCSqualaneLandingLoaded = true;

  function normalizeText(value) {
    return String(value || '').toLowerCase().replace(/[—–-]/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function updatePriceFromSelect(select) {
    if (!select) return;
    var option = select.options[select.selectedIndex];
    if (!option) return;

    var root = document;
    root.querySelectorAll('[data-mc-sq-price]').forEach(function (el) {
      el.textContent = option.getAttribute('data-price') || el.textContent;
    });
    root.querySelectorAll('[data-mc-sq-compare]').forEach(function (el) {
      el.textContent = option.getAttribute('data-compare') || el.textContent;
    });
  }

  function syncVariantSelects(sourceSelect) {
    if (!sourceSelect) return;
    var value = sourceSelect.value;
    var root = document;
    root.querySelectorAll('.mc-sq-variant-select').forEach(function (select) {
      if (select !== sourceSelect) {
        select.value = value;
      }
      updatePriceFromSelect(select);
    });
  }

  function selectedState(root) {
    var selected = root.querySelector('.mc-sq-variant-select option:checked');
    var title = selected ? normalizeText(selected.getAttribute('data-title') || selected.textContent) : '';
    return {
      title: title,
      scent: document.documentElement.getAttribute('data-selected-scent') || '',
      bundle: document.documentElement.getAttribute('data-selected-bundle') || ''
    };
  }

  function chooseVariant(root, desired) {
    var selects = root.querySelectorAll('.mc-sq-variant-select');
    if (!selects.length) return;

    var current = selectedState(root);
    var desiredScent = desired.scent || current.scent;
    var desiredBundle = desired.bundle || current.bundle;
    var match = null;
    var firstSelect = selects[0];
    var options = Array.prototype.slice.call(firstSelect.options);

    if (desiredScent && desiredBundle) {
      match = options.find(function (option) {
        var title = normalizeText(option.getAttribute('data-title') || option.textContent);
        return !option.disabled && title.indexOf(normalizeText(desiredScent)) > -1 && title.indexOf(normalizeText(desiredBundle)) > -1;
      });
    }

    if (!match && desiredScent) {
      match = options.find(function (option) {
        var title = normalizeText(option.getAttribute('data-title') || option.textContent);
        return !option.disabled && title.indexOf(normalizeText(desiredScent)) > -1;
      });
    }

    if (!match && desiredBundle) {
      match = options.find(function (option) {
        var title = normalizeText(option.getAttribute('data-title') || option.textContent);
        return !option.disabled && title.indexOf(normalizeText(desiredBundle)) > -1;
      });
    }

    if (!match) return;

    selects.forEach(function (select) {
      select.value = match.value;
      updatePriceFromSelect(select);
    });
  }

  function initScentAndBundle(root) {
    document.querySelectorAll('.mc-sq-variant-select').forEach(function (select) {
      if (select.getAttribute('data-mc-sq-select-init') === 'true') return;
      select.setAttribute('data-mc-sq-select-init', 'true');
      updatePriceFromSelect(select);
      select.addEventListener('change', function () {
        syncVariantSelects(select);
      });
    });

    root.querySelectorAll('.mc-sq-scent-card').forEach(function (card) {
      if (card.getAttribute('data-mc-sq-card-init') === 'true') return;
      card.setAttribute('data-mc-sq-card-init', 'true');
      card.addEventListener('click', function () {
        var scent = card.getAttribute('data-scent') || '';
        document.documentElement.setAttribute('data-selected-scent', scent);
        document.querySelectorAll('.mc-sq-scent-card').forEach(function (item) {
          item.classList.toggle('is-active', item === card);
        });
        chooseVariant(document, { scent: scent });
      });
    });

    root.querySelectorAll('.mc-sq-bundle-card').forEach(function (card) {
      if (card.getAttribute('data-mc-sq-card-init') === 'true') return;
      card.setAttribute('data-mc-sq-card-init', 'true');
      card.addEventListener('click', function () {
        var bundle = card.getAttribute('data-bundle') || '';
        document.documentElement.setAttribute('data-selected-bundle', bundle);
        document.querySelectorAll('.mc-sq-bundle-card').forEach(function (item) {
          item.classList.toggle('is-active', item === card);
        });
        chooseVariant(document, { bundle: bundle });
      });
    });
  }

  function initReviews(root) {
    root.querySelectorAll('.mc-sq-reviews__wrap').forEach(function (wrap) {
      if (wrap.getAttribute('data-mc-sq-init') === 'true') return;
      wrap.setAttribute('data-mc-sq-init', 'true');
      var track = wrap.querySelector('.mc-sq-reviews__track');
      var prev = wrap.querySelector('.mc-sq-review-prev');
      var next = wrap.querySelector('.mc-sq-review-next');
      if (!track) return;

      function getStep() {
        var card = track.querySelector('.mc-sq-review');
        if (!card) return track.clientWidth;
        var gap = parseFloat(window.getComputedStyle(track).gap || '18') || 18;
        return card.getBoundingClientRect().width + gap;
      }

      if (next) {
        next.addEventListener('click', function () {
          track.scrollBy({ left: getStep(), behavior: 'smooth' });
        });
      }

      if (prev) {
        prev.addEventListener('click', function () {
          track.scrollBy({ left: -getStep(), behavior: 'smooth' });
        });
      }
    });
  }

  function init(root) {
    root = root || document;
    root.querySelectorAll('.mc-sq').forEach(function (sectionRoot) {
      initScentAndBundle(sectionRoot);
      initReviews(sectionRoot);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });
})();
